import moment from 'moment'

export const convertDate = (dateString: string, dataFixedTimezone: string | undefined, addMinutes?: number): Date => {
    if (addMinutes) {
        return moment(dataFixedTimezone ? dateString : dateString + 'Z')
            .add(addMinutes, 'minutes')
            .toDate()
    }

    return moment(dataFixedTimezone ? dateString : dateString + 'Z').toDate()
}
